import type { CreateCompanyInput, UpdateCompanyInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import { createCompany, deleteCompany, updateCompany } from '../services/companies-admin.service'

export const useCreateCompanyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateCompanyInput) => await createCompany(payload),
    onSuccess: () => {
      toast.success('Empresa creada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.companies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateCompanyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateCompanyInput }) =>
      await updateCompany(id, payload),
    onSuccess: () => {
      toast.success('Empresa actualizada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.companies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteCompanyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteCompany(id),
    onSuccess: () => {
      toast.success('Empresa eliminada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.companies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
